import React from 'react';
import { Box, LinearProgress, Typography, Chip } from '@mui/material';

interface OKRProgressBarProps {
    score: number | null; // Score from 0.0 to 1.0, or null
    showLabel?: boolean;
    compact?: boolean;
}

const OKRProgressBar: React.FC<OKRProgressBarProps> = ({ score, showLabel = true, compact = false }) => {
    // Rule: NULL means Not Scorable (Not Started/Configured)
    if (score === null || score === undefined) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {showLabel && <Typography variant="caption" color="text.secondary">Not Started</Typography>}
            </Box>
        );
    }

    // Status Mapping
    // Green: >= 0.7
    // Yellow: 0.4 - 0.69
    // Red: < 0.4
    let color: 'success' | 'warning' | 'error' = 'error';
    if (score >= 0.7) color = 'success';
    else if (score >= 0.4) color = 'warning';

    const percentage = Math.round(score * 100);

    return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress
                    variant="determinate"
                    value={percentage}
                    color={color}
                    sx={{
                        height: compact ? 6 : 10,
                        borderRadius: 5,
                        bgcolor: '#e0e0e0', // Light grey background
                        '& .MuiLinearProgress-bar': {
                            borderRadius: 5,
                        }
                    }}
                />
            </Box>
            {showLabel && (
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">{`${percentage}%`}</Typography>
                </Box>
            )}
        </Box>
    );
};

export default OKRProgressBar;
